import { ConfigService } from '@/configuration/services/configService';

/**
 * Включена ли подсистема «История диалогов ChatAI». Default true; конфигом отключается
 * для контуров, где история не пишется (например, FrontVTB при History.Enabled=false на бэке).
 */
export function useChatAIHistoryEnabled(): boolean {
    return ConfigService.get().application?.AI?.chatAIHistoryEnabled !== false;
}
